import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Plantillas de Marketing Beauty',
  desc: 'Posts, stories y reels listos para usar en tus redes sociales. Solo cambia los colores y publica.'
}, {
  title: 'Acceso a Comunidad VIP',
  desc: 'Grupo privado para resolver dudas, compartir casos y hacer networking con otras profesionales.'
}, {
  title: 'Sesión 1:1 con Mentora',
  desc: 'Una llamada de 45 min para revisar tu caso específico y trazar tu plan de acción personalizado.'
}, {
  title: 'Kit de Fichas Clínicas',
  desc: 'Consentimientos informados, historias clínicas y cuidados post-tratamiento listos para imprimir.'
}, {
  title: 'Guía de Productos y Proveedores',
  desc: 'Lista completa de marcas recomendadas, dosis ideales y proveedores confiables para que ahorres tiempo.'
}, {
  title: 'Masterclass de Ventas Beauty',
  desc: 'Aprende a cerrar ventas con confianza, presentar tus servicios y convertir consultas en clientas fieles.'
}];
export const Bonuses = () => {
  return <section className="py-16 bg-white" data-id="element-28">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-29">
        <div className="text-center mb-12" data-id="element-30">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-text-main mb-3" data-id="element-31">
            Bonos exclusivos por{' '}
            <span className="text-fuchsia italic" data-id="element-32">tiempo limitado</span>
          </h2>
          <p className="text-text-muted max-w-xl mx-auto" data-id="element-33">
            Inscríbete hoy y llévate estos regalos totalmente{' '}
            <span className="font-bold text-fuchsia" data-id="element-34">GRATIS</span>.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-35">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-pink-light/20 p-6 rounded-2xl border-2 border-gold/20 flex gap-4 items-start hover:border-gold/50 transition-colors" data-id="element-36">
              <div className="w-12 h-12 bg-gradient-gold rounded-xl flex items-center justify-center shrink-0 shadow-gold-glow" data-id="element-37">
                <Gift className="w-6 h-6 text-white" data-id="element-38" />
              </div>
              <div className="flex-1" data-id="element-39">
                <div className="flex items-center gap-2 mb-2" data-id="element-40">
                  <span className="inline-block px-2.5 py-0.5 bg-gold/15 text-gold-dark text-[10px] font-bold rounded-full uppercase tracking-wider" data-id="element-41">
                    Bono #{index + 1}
                  </span>
                  <span className="inline-block px-2.5 py-0.5 bg-fuchsia text-white text-[10px] font-bold rounded-full uppercase tracking-wider" data-id="element-42">
                    Gratis Hoy
                  </span>
                </div>
                <h3 className="text-base font-bold text-text-main mb-1" data-id="element-43">
                  {bonus.title}
                </h3>
                <p className="text-text-muted text-sm leading-snug" data-id="element-44">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};